import getIgniteService from './getIgniteService';

export default function getAnswerService() {
  return getIgniteService('answerService');
}



// WEBPACK FOOTER //
// ./src/main/js/util/getAnswerService.js